import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost, { downloadFileFromResponse } from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { selectProposalDashboardFilters } from "slices/proposalDashboard/selectors";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/proposal-dashboard/widgets/sections-assignment";
const CSV_FILENAME = "Proposal Sections Assignment.csv";
const PDF_FILENAME = "Proposal Sections Assignment.pdf";

export const fetchProposalSectionsAssignment = createAsyncThunk(
  "proposalSectionsAssignment/fetch",
  async (_, { getState }) => {
    const filters = selectProposalDashboardFilters(getState());
    const { periodStart, periodEnd } = resolvePeriod(filters);
    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd },
    });
    return data;
  },
);

export const exportProposalSectionsAssignmentCsv = () => async (dispatch, getState) => {
  try {
    const filters = selectProposalDashboardFilters(getState());
    const { data } = await localhost.get(`${BASE_URL}/export/csv`, {
      responseType: "blob",
      params: resolvePeriod(filters),
    });
    downloadFileFromResponse(data, CSV_FILENAME);
  } catch (err) {
    dispatch(showErrorModal(err));
  }
};

export const exportProposalSectionsAssignmentPdf = () => async (dispatch, getState) => {
  try {
    const filters = selectProposalDashboardFilters(getState());
    const { data } = await localhost.get(`${BASE_URL}/export/pdf`, {
      responseType: "blob",
      params: resolvePeriod(filters),
    });
    downloadFileFromResponse(data, PDF_FILENAME);
  } catch (err) {
    dispatch(showErrorModal(err));
  }
};
